var scroll = {
    dir : 0,

    parallax : ()=>{
        let pos = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        let header = helper.element("header");
        let lines = helper.element(".background-lines");
        let nav = helper.element(".nav", false);

        let apple = helper.element(".apple", false);

        if (header) {
            if (pos > 30 && !nav.classList.contains("active")) {
                header.classList.add("scroll");
            } else {
                header.classList.remove("scroll");
            }

            if (pos > scroll.dir && pos > 150 && !nav.classList.contains("active")) {
                header.classList.add("hidden");
            } else {
                header.classList.remove("hidden");
            }
        }
        lines.style.top = (pos * -.64) + "px";
        scroll.dir = pos;
    }
};